export const showCollectionSellingInfo = (
  isSelling: boolean,
  pricing: number,
  currency: string,
  isStudent: boolean
) =>
  isSelling &&
  pricing !== null &&
  pricing !== 0 &&
  currency !== null &&
  !isStudent
